import {
  AiOutlineSearch,
  AiOutlineVideoCamera,
  AiFillAmazonCircle,
} from "react-icons/ai";
import { GiConfirmed } from "react-icons/gi";
import { BiGitCompare } from "react-icons/bi";
import { TbTruckReturn } from "react-icons/tb";

export const menuConfig = [
  {
    id: 200,
    name: "Appointment List",
    href: "/home",
    // css: <TbTruckReturn />,
    type: 1,
    // children: [],
  },
  {
    id: 300,
    name: "Terminal Account",
    href: "/account",
    // css: <TbTruckReturn />,
    type: 1,
    // children: [],
  },
];
